import { EpisodeWithUser } from "./episodes-types";
import { SubmissionState } from "./submission-types";

// request params
export type ImageParams = {
  imageId: string;
};

export type ImageBase = {
  id: string;
  isChildPresented: boolean;
  page: number;
  state: ImageState;
  submissionState: SubmissionState;
  url?: string;
  manualEditState: ManualEditState | null;
  needsManualEdit: boolean;
  createdAt: string;
  updatedAt: string;
  rejectionReasons: string[];
  rejectionNotes?: string;
  modelName: string | null;
  generationTime: number | null;
  generationId: string | null;
  generationError: string | null;
};

export type ImageDetails = ImageBase & {
  episodeTitle: string;
  pageText: string;
  prompt: string;
  episode: EpisodeWithUser;
  previousImagesCount: number;
};

export type ChangeIsChildPresentedData = {
  isChildPresented: boolean;
};

export enum ManualEditState {
  unfixed = "unfixed",
  downloaded = "downloaded",
  awaiting_mask = "awaiting_mask",
  fixed = "fixed",
}

// subset of Image and some of its related entities
export type ImageNeedingManualEdit = {
  id: string;
  isChildPresented: boolean;
  episode: {
    id: string;
  };
  manualEditState: ManualEditState | null;
  nextImage: {
    id: string;
    mask: {
      id: string;
      url: string;
    } | null;
    url: string;
  } | null;
  url: string;
  rejectionReasons: string[];
  rejectionNotes?: string;
};

export enum ImageState {
  "waitingForImage" = "waitingForImage",
  "waitingForChildDetection" = "waitingForChildDetection",
  "generationFailed" = "generationFailed",
  "retryScheduled" = "retryScheduled",
  "new" = "new",
  "accepted" = "accepted",
  "rejected" = "rejected",
}

// removed previous type, that were simply incorrect and probably AI-generated.
// replaced with temporary stubs and minimal schema based on actual usage on frontend.
export type ImageUploadResponseData = {
  old_image: unknown;
  new_image: {
    images: unknown[];
  };
};

export type GenerationStatusResponse = {
  generation_type: string;
  overall_status: string;
  success: boolean;
  error_message: string | null;
  created_at: string;
  started_at: string | null;
  completed_at: string | null;
};
